import { MouseEvent, type JSX } from 'react';
import { theme } from "../../../../theme/theme"
import { V3IconChevronRight, V3IconRedirect } from "../../../Icons"
import { UnstyledInlineLink } from "../../../ReusableStyledComponents/UnstyledLink"
import { V3HeadlineH5 } from "../../../Typography"
import { RoundedBoxCTAWrapper, RoundedVoxCTAContainer, SecondaryTextWrapper } from "./RoundedBoxCTA.styles"
import { V3CaptionGrey35 } from '../../../ReusableStyledComponents/V3CaptionGrey35';
import { FloatingMouseTooltip } from '../../../FloatingMouseTooltip';

export interface RoundedBoxCTAProps {
    href?: string,
    onClick?: () => void,
    text: string,
    secondaryText?: string | JSX.Element,
    disabled?: boolean,
    customIcon?: JSX.Element,
    skipTargetBlank?: boolean
    tooltip?: string,
}

export const RoundedBoxCTA = ({ href, onClick, text, disabled = false, customIcon, skipTargetBlank = false, secondaryText, tooltip }: RoundedBoxCTAProps) => {

    const handleClick = (event?: MouseEvent<HTMLAnchorElement>): void => {
        if (event) event.preventDefault();
        if (href) {
            if (!skipTargetBlank) window.open(href, '_blank');
            // Loaded on demand so consumers outside of Next - the browser extension - never pull the router into their bundle
            else import("next/router").then(({ default: Router }) => Router.push(href));
        }
        if (onClick) onClick();
    };

    const mainElem = <UnstyledInlineLink
        href={href}
        onClick={(e) => disabled ? undefined : handleClick(e)}
        target={disabled ? undefined : !!href ? "_blank" : undefined}
        tabIndex={0}
        onKeyDown={(e) => {
            if (e.key === "Enter") {
                disabled ? undefined : handleClick();
            }
        }}
    >
        <RoundedVoxCTAContainer $disabled={disabled}>
            <RoundedBoxCTAWrapper >
                <div>
                    {customIcon}
                    <V3HeadlineH5><strong>{text}</strong></V3HeadlineH5>
                    {
                        !!href?.length && <V3IconRedirect stroke={theme.v3.colors.ink} />
                    }
                </div>
                <div>
                    <V3IconChevronRight opacity="1" stroke={disabled ? theme.v3.colors.grey88 : undefined} />
                </div>
            </RoundedBoxCTAWrapper>
            {
                !!secondaryText && <SecondaryTextWrapper>
                    <V3CaptionGrey35>{secondaryText}</V3CaptionGrey35>
                </SecondaryTextWrapper>
            }
        </RoundedVoxCTAContainer>
    </UnstyledInlineLink>

    if (!!tooltip?.length) {
        return <FloatingMouseTooltip
            text={tooltip}
        >{mainElem}</FloatingMouseTooltip>
    } else {
        return mainElem
    }
}